







import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
    name: 'ExportButtons',
    computed: {
        ...mapGetters('root', ['label']),
    }
})

export default class ExportButtons extends Vue {
    private labelModule = 'ModuleOverview';

    private setPopup(name: string): void {
        this.$store.commit('root/setPopupComponent', {
            name
        });
    }
}
